<template>
  <div class="plk-basic-table">
    <div class="title text-center" v-if="plkparams.title || plkparams.showFiltersInHeader">
      {{$t(plkparams.title)}} {{this.showFiltersInHeader}}
    </div>
    <div class="text-center p-2 loading" v-if="loading"> {{$t('plk.basictable.obtainingdata')}} </div>
    <div class="content">
      <table class="u-full-width" v-if="!loading">
        <thead>
          <tr class="tr-headers">
            <th v-for="(column, columnId) in columns" :key="`columns-${columnId}`" @click="clearFilter(column)" :class="{ 'clear': isFiltered(column) }">
              {{convertInTitle(column.idElement)}}<sup><i class="filter fas fa-filter" :title="$t('plk.basictable.clearfilter')" v-if="isFiltered(column)"></i></sup>
            </th>
            <th v-for="(measure, meassureId) in measures" :key="`measure-${meassureId}`">{{convertInTitle(measure.idElement)}}</th>
          </tr>
        </thead>
        <tr class="tr-values" v-for="(element, index) in tbody" :key="index">
          <td class="td selectable" v-for="(col, iCol) in element.row" :key="`columns-${iCol}`" @click="applyFilters(element.row);">
            <span @click.stop="applyFilter(col)">{{$t(col.id)}} </span>
          </td>
          <td class="td" v-for="(value, iCol) in element.values" :key="`values-${iCol}`">{{value}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import services from '@/services'
import configuration from './package.json'
import readme from './README.md'
import BasicComponentMixin from '@/mixins/component'
import { PLAKA } from '@/store'
export const TYPE = services.component.normalizeType('BasicTable')

export default {
  name: TYPE,
  mixins: [
    BasicComponentMixin
  ],
  data () {
    return {
      loading: true,
      cube: undefined
    }
  },
  computed: {
    filters () {
      return this.connectionStarted ? this.$store.getters[PLAKA.GETTERS.GET_FILTERS](this.columns.concat(this.plkparams.conditions || []).map(e => e.idElement)) : []
    },
    tbody () {
      let data = []
      if (this.cube) {
        this.cube.getDimensionsOptionsInRow().forEach(row => {
          let values = []
          this.cube.getMeasuresValues().forEach(meassure => {
            let value = this.cube.getValueByOptions(row.concat(meassure))
            if (value) {
              values.push(value)
            }
          })
          if (this.plkparams.showNull || values.length) {
            data.push({
              row,
              values
            })
          }
        })
      }
      return data
    },
    elements () {
      return this.plkparams.elements || []
    },
    measures () {
      return this.elements.filter(e => e.type === this.getConnection().ELEMENT_TYPES.MEASURE)
    },
    columns () {
      return this.elements.filter(e => e.type === this.getConnection().ELEMENT_TYPES.COLUMN)
    },
    selectedMeasures () {
      return this.measures.length
    },
    selectedColumns () {
      return this.columns.length
    }
  },
  methods: {
    applyFilters (filters = []) {
      if (this.plkparams.onClickRow) {
        this.executeFunction(this.plkparams.onClickRow, filters)
      } else {
        let elements = []
        filters.forEach(f => {
          let element = this.columns.find(c => c.idElement === f.parent)
          if (element) {
            element.values = [f.id]
            elements.push(element)
          }
        })
        this.getConnection().applyFilters(elements, { overwrite: false })
      }
    },
    applyFilter ({ parent = '', id = '' } = {}) {
      let element = this.columns.find(c => c.idElement === parent)
      if (!element) {
        console.warn(`Not found element '${id}'`)
        return
      }
      element.values = [id]
      if (this.plkparams.onFilter) {
        this.executeFunction(this.plkparams.onFilter, element)
      } else {
        this.getConnection().applyFilter(element, { overwrite: false })
      }
    },
    onDestroyComponent () {
      this.stopData()
    },
    startData () {
      if (this.getConnection() && this.selectedColumns && this.selectedMeasures) {
        this.getConnection().initData(this.elements, this.plkparams.conditions || [], { onInit: this.onInitLoad, onChange: this.onChangeData })
      } else {
        console.warn(`Necesary element type '${this.getConnection().ELEMENT_TYPES.COLUMN}' and '${this.getConnection().ELEMENT_TYPES.MEASURE}' to create ${TYPE}`)
      }
    },
    stopData () {
      if (this.connectionStarted) {
        this.getConnection().stopData({ onInit: this.onInitLoad, onChange: this.onChangeData })
      }
    },
    onInitLoad () {
      Vue.set(this, 'loading', true)
    },
    onChangeData (cube) {
      Vue.set(this, 'cube', cube)
      this.cube.setElements({
        rows: this.columns,
        cols: [],
        filters: []
      })
      Vue.set(this, 'loading', false)
    },
    getPackage () {
      return configuration
    },
    getReadme () {
      return readme
    }
  },
  watch: {
    connectionStarted () {
      if (this.connectionStarted && this.getConnection().type === this.$servicesPLK.connection.TYPE.PLAKA) {
        this.startData()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.plk-basic-table table th,
.plk-basic-table table td {
  padding-left: 1rem;
  padding-right: 1rem;
}

.plk-basic-table .selectable,
.plk-basic-table .clear {
  cursor: pointer;
}

.plk-basic-table thead {
  white-space: nowrap;
}

.plk-basic-table .filter {
  font-size: 0.7em;
  cursor: pointer;
}

.plk-basic-table .table-header,
.plk-basic-table .loading {
  background: white;
}

.plk-basic-table .tr-values:hover {
  background-color: #f5f5f5;
}
.plk-basic-table .content {
  overflow: auto;
}
</style>
